import * as React from 'react';
import { Stack } from '../../Stack';
import { getTheme } from 'office-ui-fabric-react';
import { jsx as _jsx } from "react/jsx-runtime";
export const FlyoutContainer = _ref => {
  let {
    children
  } = _ref;
  const theme = getTheme();
  const styles = {
    root: {
      borderTop: "solid 2px ".concat(theme.palette.themePrimary),
      paddingTop: 20,
      marginTop: 10
    }
  };
  return /*#__PURE__*/_jsx(Stack, {
    styles: styles,
    children: children
  });
};